module.exports = __webpack_public_path__ + "img/6c.f527501e.png";